/**
 * EGD hub data source: `ers` (legacy) or `payload` (pg-payload-cms).
 * Temporarily follows REACT_APP_PROMOTIONS_SOURCE (same as entertainment).
 * @returns {'ers' | 'payload'}
 */
export function getEgdSource() {
  const raw = process.env.REACT_APP_PROMOTIONS_SOURCE || "ers";
  const source = raw.split("#")[0].trim().toLowerCase();
  return source === "payload" ? "payload" : "ers";
}

export function isPayloadEgdSource() {
  return getEgdSource() === "payload";
}
